import api from '@/plugins/api';

export default class CoreNews {
  constructor(parent) {
    this.$parent = parent;
    this.messages = [];
    this.key = '';
    this.old = window.localStorage.getItem('mini.mag:news');
  }

  init() {
    const self = this;
    return new Promise((resolve, reject) => {
      api.news
        .list()
        .then((data) => {
          self.messages = data.messages;
          self.key = data.hash_ids;
        }, reject);
    });
  }

  get message() {
    return this.messages?.[0] || null;
  }

  get badge() {
    return this.key ? (this.key !== this.old) : false;
  }

  read() {
    if (this.key) {
      this.old = this.key;
      window.localStorage.setItem('mini.mag:news', this.key);
    }
  }
}
